import React from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const Column = ({ noPadding, children, ...props }) => {
    if (props.col0) {
        return null;
    }
    return (React.createElement("div", { style: {
            padding: noPadding === true ? 0 : undefined,
        }, className: classNames(midas.column, ...Object.keys(props)
            .filter((key) => key !== 'children')
            .filter((key) => /col.*/g.test(`${key}`))
            .map((key) => midas[key])) }, children));
};
export default Column;
